<template>
  <div>
    <KeywordSearch :error="requirementsError">
      <template #title>
        <h1 class="mb-1 mt-0 text-2xl">
          {{
            checkoutStore.matchingCriteria.step === 'candidates'
              ? `Let’s refine your search.`
              : `Let’s refine the tasks you need help with?`
          }}
        </h1>
      </template>
      <template #body>
        <p class="max-w-2xl text-left text-sm">
          {{
            checkoutStore.matchingCriteria.step === 'candidates'
              ? ` Enter as many as you like
          - the more the better.`
              : `Add as many requirements as you like - the more the better so we get a really
          good idea of what you’re looking for.`
          }}
        </p>
      </template>
    </KeywordSearch>
    <word-selector :title="`Your Requirements`">
      <template #body>
        <span class="text-sm">
          Add or remove requirements or if you're happy proceed by clicking
          “NEXT”
        </span>
      </template>
    </word-selector>
  </div>
</template>
<script>
import KeywordSearch from '@/components/serviceSelection/KeywordSearch.vue';
import WordSelector from '@/components/serviceSelection/WordSelector.vue';
import { mapStores } from 'pinia';
import { useCheckoutStore } from '@/stores/checkout';

export default {
  name: 'RequirementsSelector',
  components: {
    KeywordSearch,
    WordSelector,
  },
  props: {
    requirementsError: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {};
  },
  computed: {
    ...mapStores(useCheckoutStore),
  },
};
</script>
